import React from 'react';

function SensorWater() {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_241_1075)">
        <path
          d="M73.132 57.196C73.648 53.952 74 47.47 74 39.994C74 32.518 73.646 25.99 73.126 22.76C71.948 14.53 65.432 8.028 57.196 6.868C53.952 6.352 47.47 6 39.994 6C32.518 6 25.992 6.354 22.76 6.874C14.53 8.052 8.028 14.568 6.868 22.804C6.352 26.048 6 32.53 6 40.006C6 47.482 6.354 54.01 6.874 57.24C8.052 65.47 14.568 71.972 22.804 73.132C26.048 73.648 32.53 74 40.006 74C47.482 74 54.01 73.646 57.24 73.126C65.47 71.948 71.972 65.432 73.132 57.196Z"
          fill="#F7F4F1"
        />
        <path
          d="M40.0042 74.8C32.7222 74.8 26.0822 74.464 22.6782 73.922C14.1362 72.72 7.3062 65.906 6.0822 57.352C5.5382 53.972 5.2002 47.32 5.2002 40.004C5.2002 32.688 5.5362 26.08 6.0782 22.678C7.2802 14.136 14.0942 7.30595 22.6462 6.08195C26.0282 5.53795 32.6802 5.19995 39.9942 5.19995C47.3082 5.19995 53.9162 5.53595 57.3202 6.07795C65.8622 7.27995 72.6922 14.094 73.9162 22.646C74.4602 26.026 74.7982 32.68 74.7982 39.994C74.7982 47.308 74.4622 53.908 73.9202 57.314C72.7122 65.866 65.9002 72.692 57.3502 73.916C53.9682 74.46 47.3162 74.798 40.0022 74.798L40.0042 74.8ZM39.9942 6.79995C32.7602 6.79995 26.2042 7.13195 22.8862 7.66395C15.0222 8.78995 8.7662 15.062 7.6602 22.916C7.1282 26.256 6.8002 32.8 6.8002 40.006C6.8002 47.212 7.1302 53.798 7.6642 57.114C8.7902 64.98 15.0602 71.236 22.9162 72.342C26.2582 72.874 32.8002 73.202 40.0062 73.202C47.2122 73.202 53.7962 72.87 57.1142 72.338C64.9782 71.212 71.2342 64.94 72.3402 57.086C72.3402 57.082 72.3402 57.076 72.3422 57.072C72.8722 53.744 73.2002 47.202 73.2002 39.996C73.2002 32.79 72.8702 26.204 72.3362 22.888C71.2102 15.022 64.9382 8.76595 57.0842 7.65995C53.7422 7.12795 47.2002 6.79995 39.9942 6.79995V6.79995Z"
          fill="#84827E"
        />
        <path
          d="M29.6463 39.9999C29.6463 41.4359 28.4823 42.5999 27.0463 42.5999C25.6103 42.5999 24.4463 41.4359 24.4463 39.9999C24.4463 38.5639 25.6103 37.3999 27.0463 37.3999C28.4823 37.3999 29.6463 38.5639 29.6463 39.9999Z"
          fill="url(#paint0_linear_241_1075)"
        />
        <path
          d="M55.5545 39.9999C55.5545 41.4359 54.3905 42.5999 52.9545 42.5999C51.5185 42.5999 50.3545 41.4359 50.3545 39.9999C50.3545 38.5639 51.5185 37.3999 52.9545 37.3999C54.3905 37.3999 55.5545 38.5639 55.5545 39.9999Z"
          fill="url(#paint1_linear_241_1075)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_241_1075"
          x="3.8002"
          y="3.79995"
          width="75.5977"
          height="75.6001"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1.6" dy="1.6" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_241_1075"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_241_1075"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_241_1075"
          x1="25.1777"
          y1="37.865"
          x2="28.7074"
          y2="41.9139"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#82D1AD" />
          <stop offset="1" stopColor="#00A872" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_241_1075"
          x1="51.0859"
          y1="37.865"
          x2="54.6157"
          y2="41.9139"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#82D1AD" />
          <stop offset="1" stopColor="#00A872" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default SensorWater;
